import cn from 'classnames';
import { ErrorBoundary } from 'react-error-boundary';
import { Link } from '#components/atoms/link/Link.tsx';
import { MissingEntity } from '#components/atoms/missing-entity/MissingEntity.tsx';
import { useAppLocation } from '#hooks/useAppLocation.ts';
import { MissingRoleError, useRoleName } from '#hooks/useRoleName.ts';

type Props = { roleID: string; className?: string };

/**
 * Renders a link to a role detail page, fetching its name to show
 */
export function RoleLink(props: Props) {
  return (
    <ErrorBoundary
      fallbackRender={({ error }) => {
        if (error instanceof MissingRoleError) {
          return <MissingEntity entityId={error.entityId} />;
        }

        throw error;
      }}
    >
      <InnerRoleLink {...props} />
    </ErrorBoundary>
  );
}

function InnerRoleLink({ roleID, className }: Props) {
  const location = useAppLocation();
  const roleName = useRoleName(roleID);

  return (
    <Link to={`/roles/${roleID}`} state={{ from: location }} className={cn('a', className)}>
      {roleName}
    </Link>
  );
}
